import type { MemberPermissionResponse } from '@/types/business/member';
import type { PermissionListItem } from '@/types/business/permission';
import type { BaseResponse } from '@/types/common/http';
import { request } from '@/utils/request';

/**
 * 获取所有权限
 */
export const getPermissionList = () => {
  return request.get<BaseResponse<PermissionListItem[]>>('/permission');
};
/**
 * 获取所有权限（创建）
 */
export const getPermissionListByCreate = () => {
  return request.get<BaseResponse<PermissionListItem[]>>('/roles/perms/data/create');
};
/**
 * 获取所有权限（编辑）
 */
export const getPermissionListByEdit = () => {
  return request.get<BaseResponse<PermissionListItem[]>>('/roles/perms/data/update');
};
/**
 * 获取所有权限（查询）
 */
export const getPermissionListByQuery = () => {
  return request.get<BaseResponse<PermissionListItem[]>>('/roles/perms/data/list');
};

/**
 * 获取当前用户权限
 */
export const getCurrentUserPermissions = () => {
  return request.get<BaseResponse<MemberPermissionResponse>>('/profile/perms');
};
